import React, { useState } from 'react';
import { Button } from './button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from './alert-dialog';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Lock } from 'lucide-react';

export const Paywall = ({
  title,
  descriptions,
  previewable,
  contactMe,
  startPreview,
}: {
  title: string;
  descriptions: string[];
  previewable: boolean;
  contactMe: () => void;
  startPreview: () => void;
}) => {
  const history = useHistory();
  const [clickedContact, setClickedContact] = useState(false);
  return (
    <div className="absolute inset-0 z-50  backdrop-blur">
      <div className="fixed right-[50%] top-[12%] translate-x-[50%]  z-50 grid w-full max-w-[600px]   gap-4 border bg-background p-6 shadow-lg duration-200  sm:rounded-lg">
        <div className="flex justify-between">
          <h2 className="font-bold text-xl">{clickedContact ? "We'll call you" : title}</h2>
          <Lock />
        </div>
        <ul>
          {clickedContact
            ? "Thanks for your interest. We'll get in touch soon"
            : descriptions.map((d) => (
                <li key={d} className="text-lg">
                  ✨ {d}
                </li>
              ))}
        </ul>
        {previewable && (
          <>
            <div>You can preview this premium feature now for a limited amount of time. </div>
            <div className="flex justify-end">
              <AlertDialog>
                <AlertDialogTrigger asChild>
                  <Button className="w-36">Preview now</Button>
                </AlertDialogTrigger>
                <AlertDialogContent>
                  <AlertDialogHeader>
                    <AlertDialogTitle>Start free preview of Sustainability Insights?</AlertDialogTitle>
                    <AlertDialogDescription>
                      <p>
                        Your data will be loaded right after you confirm this free preview by clicking the button below.
                      </p>
                      <p className="my-4">
                        <em>The free preview will end tomorrow.</em>
                      </p>
                      <p>We will contact you soon because we would like to hear your opinion about this feature.</p>
                    </AlertDialogDescription>
                  </AlertDialogHeader>
                  <AlertDialogFooter>
                    <AlertDialogCancel>Cancel</AlertDialogCancel>

                    <AlertDialogAction onClick={startPreview}>Start free preview</AlertDialogAction>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialog>
            </div>
          </>
        )}
        {!previewable &&
          (!clickedContact ? (
            <>
              <div>Please use the button below and we will contact you about this feature.</div>
              <div className="flex justify-end">
                <Button
                  onClick={() => {
                    setClickedContact(true);
                    contactMe();
                  }}
                >
                  Contact me
                </Button>
              </div>
            </>
          ) : (
            <div className="flex justify-end">
              {' '}
              <Button variant="link" className="text-sky-600" onClick={() => history.push('/home')}>
                Go back to home
              </Button>
            </div>
          ))}
      </div>
    </div>
  );
};
